import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../announcements";
import { Adapter } from "../../../../shared/adapter";
import { AnnouncementsAdapter } from "../../../../adapter/announcements -adapter";

export const FETCH_DATA_ANNOUNCEMENTS_REQUEST = 'FETCH_DATA_ANNOUNCEMENTS_REQUEST';
export const FETCH_DATA_ANNOUNCEMENTS_SUCCESS = 'FETCH_DATA_ANNOUNCEMENTS_SUCCESS';
export const FETCH_DATA_ANNOUNCEMENTS_FAILURE = 'FETCH_DATA_ANNOUNCEMENTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataAnnouncementsRequest = () => {
    return {
        type: FETCH_DATA_ANNOUNCEMENTS_REQUEST,
    };
};

const fetchDataAnnouncementsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_ANNOUNCEMENTS_SUCCESS,
        payload: data
    };
};

const fetchDataAnnouncementsFailure = (error: any) => {
    return {
        type: FETCH_DATA_ANNOUNCEMENTS_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataAnnouncementsRequest());
        try {
            const response = await Find('announcement', query, page, pageSize);
            console.log("announcement", Adapter.from(response.data).to((value) => new AnnouncementsAdapter(value).adapt()));
            dispatch(fetchDataAnnouncementsSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new AnnouncementsAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataAnnouncementsFailure(error.message));
        }
    };
};
